<template>
  <!-- 话务弹窗集合 -->
  <div class="auto-dial">
    <UpdateCallRecord
      v-if="visibleUpdateCallRecord"
      :callId="callerWindowState.hangupCallId"
      @onClose="onCloseUpdateCallRecord"
      @onConfirm="onConfirmUpdateCallRecord"
    />
    <div class="auto-dial-window" v-show="autoDialVisible">
      <div class="auto-dial-wrap">
        <div class="areaInfo">
          继续拨打下一用户？
        </div>
        <div class="callStatus">
          <span v-if="!autoDialPause">将在<b>{{dialCallCount}}s</b>后为您拨打下一用户</span>
          <span v-if="autoDialPause">当前状态为暂停中，点击【继续拨打】按钮可继续</span>
        </div>
        <div class="buttons">
          <el-button type="primary" size="medium" class="un-mute" plain v-if="!autoDialPause" @click="pauseDialCall">暂停</el-button>
          <el-button size="medium" class="un-mute" plain v-else @click="closeDialCall">取消自动拨打</el-button>
          <el-button type="primary" size="medium" class="mute" plain @click="startDialCall">继续拨打</el-button>
        </div>
      </div>
    </div>
    <div class="auto-dial-window" v-show="callerWindowState.autoDialCount > 0">
      <div class="auto-dial-count-wrap">
        <img src="@/assets/images/login/close.png" alt="" class="close" @click="closeDialCall">
        <img src="@/assets/images/loading.png" alt="" class="loading">
        <div class="rotate">
          <p class="title">暂无工单</p>
          <p class="time">已等待{{filterTimer(callerWindowState.autoDialCount)}}</p>
        </div>
      </div>
    </div>
    <div class="auto-dial-window" v-show="callerWindowState.customerCallFail">
      <div class="auto-dial-wrap">
        <div class="areaInfo">
          继续拨打下一用户？
        </div>
        <div class="callStatus">
          <span>当前用户呼叫异常，是否继续拨打下一用户</span>
        </div>
        <div class="buttons">
          <el-button size="medium" class="un-mute" plain @click="closeDialCall">取消自动拨打</el-button>
          <el-button type="primary" size="medium" class="mute" plain @click="startDialCall">继续拨打</el-button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import UpdateCallRecord from './UpdateCallRecord.vue';
import { callHelper } from "@/utils/helper/caller.helper";
import { callerWindowState } from "@/utils/helper/caller.window.state";

export default {
  components: {
    UpdateCallRecord,
  },
  data() {
    return {
      callHelper,
      callerWindowState,
      autoDialVisible: false,
      autoDialPause: false,
      dialCallTimer: null,
      dialCallCount: 5,
      // hasUpdateCallRecord: false, //是否已上报通话记录
    }
  },
  computed: {
    // 弹窗显隐-上报通话记录
    visibleUpdateCallRecord(){
      const {callerWindowState} = this;
      return callerWindowState.callWindowStatus === 'ON_WAITING' && 
        !callerWindowState.customerCallFail && 
        callerWindowState.hangupCallId &&
        callerWindowState.callSuccess;
    },
  },
  watch: {
    "callerWindowState.callWindowStatus"(newV){
      if (newV === "ON_WAITING"){
        // 如果没有工单id，不出通话记录弹窗，直接走通话记录弹窗的关闭回调
        if (sessionStorage.getItem('noJobOrderId') === '1'){
          this.onCloseUpdateCallRecord();
        }
      }
    },
    // "callerWindowState.callWindowStatus"(newV, oldV){
    //   if (newV !== "ON_WAITING") this.hasUpdateCallRecord = false;
    // }
    // "callerWindowState.callWindowStatus"(newV, oldV) {
    //   if (newV === "ON_WAITING" && !this.callerWindowState.customerCallFail) {
    //     this.autoSaveSaleStateAndCallNext()
    //   }
    // }
  },
  methods: {
    pauseDialCall() {
      this.autoDialPause = true
      this.dialCallCount = 5
      clearInterval(this.dialCallTimer)
    },
    closeDialCall() {
      this.autoDialVisible = false
      clearInterval(this.dialCallTimer)
      this.autoDialPause = false
      this.dialCallTimer =  null
      this.dialCallCount = 5
      this.callHelper.closeAutoDial()
    },
    startDialCall() {
      this.autoDialVisible = false
      clearInterval(this.dialCallTimer)
      this.autoDialPause = false
      this.dialCallTimer =  null
      this.dialCallCount = 5
      this.callHelper.startAutoDial()
    },
    // 自动上传通话情况并开始拨打下一个用户
    autoSaveSaleStateAndCallNext() {
      if (this.callerWindowState.customerCallFail) return;
      
      // 如果 是养老bpo自动拨打坐席 && 自动外呼处于开启状态，就打开继续拨打弹窗
      if (this.callerWindowState.autoDialStateDesc) {
        this.autoDialPause = false
        this.autoDialVisible = true
        this.dialCallTimer = setInterval(() => {
          if (this.dialCallCount <= 0) {
            this.dialCallCount = 0
            clearInterval(this.dialCallTimer)
            this.startDialCall()
          } else {
            this.dialCallCount --
          }
        }, 1000)
      }
    },
    filterTimer(time) {
      let minute = Math.floor(time / 60) ;
      let miao = time % 60
      if (minute <= 0) {
        return miao + "秒"
      }
      return minute + "分钟" + miao + "秒"
    },
    // 上报通话记录提交后回调
    onConfirmUpdateCallRecord(){
      this.onCloseUpdateCallRecord();
    },
    // 上报通话记录关闭后回调
    onCloseUpdateCallRecord(){
      this.callerWindowState.setCallWindowStatus("");
      this.callerWindowState.setCallSuccess(false);
      sessionStorage.removeItem('noJobOrderId');
      this.autoSaveSaleStateAndCallNext();
    },
  }
}
</script>

<style lang="scss" scoped src="./index.scss">

</style>
